import { useAccountHostingList } from '@newfold/huapi-js';

import useAccount from './useAccount';
import useFeature from './useFeature';

const useDataCenter = () => {
  const [hasSites] = useFeature('sites');
  const [isAdvancedHosting] = useFeature('advanced_hosting');

  const { id: hostingId } = useAccount();

  const {
    data: accounts,
    isPending,
    isError,
  } = useAccountHostingList(undefined, {
    query: {
      enabled: hasSites || isAdvancedHosting,
      select: ({ data: { accounts } }) => accounts,
    },
  });

  const hostingList = accounts || [];

  const matchingAccount = Array.isArray(hostingList)
    ? hostingList.find(
        (account) =>
          String(account?.hosting_id) === String(hostingId) ||
          String(account?.prod_inst_id) === String(hostingId),
      )
    : null;

  const dCName = matchingAccount?.region_desc || '';
  const dCType = matchingAccount?.region_type || '';

  return {
    data: hostingList,
    isPending,
    isError,
    dCName,
    dCType,
  };
};

export default useDataCenter;
